/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/alt-text */
import cx from 'classnames';
import { h, Component } from 'preact';
import debounce from './utils/debounce';
import { lookup } from './utils/legislative-districts';
import { widont } from 'journalize';
import { get, set } from 'idb-keyval';

import asyncComponent from './components/AsyncComponent';
import Portal from './components/Portal';
import Typeahead from './components/Typeahead';
import DistrictViewer from './components/DistrictViewer';

// const googleIMG = loadAssetURL('powered-by-google');
const googleIMG = '../assets/powered-by-google.png';

const AsyncDistrictViewer = asyncComponent(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "DistrictViewer" */ './components/DistrictViewer'
  )
);

// we import the google script in the base template
// eslint-disable-next-line no-undef
const sessionToken = new google.maps.places.AutocompleteSessionToken();
// eslint-disable-next-line no-undef
const autocompleteService = new google.maps.places.AutocompleteService();

const bounds = {
  east: -93.514764,
  west: -106.662177,
  south: 25.843902,
  north: 36.500199,
};
const componentRestrictions = { country: 'us' };
const types = ['geocode'];

const getPredictions = input => {
  return new Promise((resolve, reject) => {
    autocompleteService.getPlacePredictions(
      { bounds, componentRestrictions, input, sessionToken, types },
      (predict, status) => {
        if (status === 'OK') resolve(predict);

        reject(new Error('No results found.'));
      }
    );
  });
};

// always render what's provided, the geocoder decides
const shouldItemRender = () => true;

class Locator extends Component {
  constructor() {
    super();

    this.state = {
      coordinates: null,
      data: null,
      lookupError: false,
      lookupPending: false,
      lookupDefault: true,
      placeholder: null,
      results: [],
      value: '',
      bodyWidth: null,
      width: null,
      revisit: false,
      yourDistrict: false,
    };

    this.handleGeocode = this.handleGeocode.bind(this);
    this.debouncedHandleGeocode = debounce(this.handleGeocode, 300);
    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onSelect = this.onSelect.bind(this);
  }

  getContainerWidth() {
    const bodyWidth = window.innerWidth;
    const width =
      bodyWidth > 543 ? 220 : bodyWidth > 330 ? 280 : bodyWidth - 70;
    this.setState({
      width: width,
      bodyWidth: bodyWidth,
    });
  }

  componentDidMount() {
                        // eslint-disable-next-line no-undef
                        this.placesService = new google.maps.places.PlacesService(
                          this.inputRef
                        );

                        let listPlaces = [
                          {
                            lat: 30.274943387487465,
                            lng: -97.74034480255501,
                            name: '1100 Congress Avenue, Austin, TX',
                          },
                          {
                            lat: 35.20710437159758,
                            lng: -101.83113348707214,
                            name: '601 South Buchanan Street, Amarillo, TX',
                          },
                          {
                            lat: 31.762156823205473,
                            lng: -106.48483254484304,
                            name: '300 North Campbell Street, El Paso, TX',
                          },
                          {
                            lat: 32.776424239890645,
                            lng: -96.79737438899544,
                            name: '1500 Marilla Street, Dallas, TX',
                          },
                          {
                            lat: 29.76042281652034,
                            lng: -95.36931644489614,
                            name: '901 Bagby Street, Houston, TX',
                          },
                          {
                            lat: 29.424599165933195,
                            lng: -98.49513996383381,
                            name: '100 Military Plaza, San Antonio, TX',
                          },
                          {
                            lat: 32.749514660413084,
                            lng: -97.33085531783236,
                            name: '200 Texas Street, Fort Worth, TX',
                          },
                          {
                            lat: 33.58300374154896,
                            lng: -101.84822318711977,
                            name: '1314 Avenue K, Lubbock, TX',
                          },
                          {
                            lat: 25.90265625850097,
                            lng: -97.49928206033408,
                            name: '1001 East Elizabeth Street, Brownsville, TX',
                          },
                          {
                            lat: 31.55899831718868,
                            lng: -97.12957547368465,
                            name: '300 Austin Avenue, Waco, TX',
                          },
                        ];
                        let randomIndex = Math.floor(Math.random() * 9);

                        let latitude = listPlaces[randomIndex].lat;
                        let longitude = listPlaces[randomIndex].lng;
                        let placeName = listPlaces[randomIndex].name;
                        let coordinates = { latitude, longitude };

                        // check if revisited
                        get('your-races-lookup')
                          .then(dbData => {
                            get('your-races-address').then(addressData => {
                              if (dbData) {
                                this.setState({
                                  data: dbData,
                                  lookupPending: false,
                                  lookupDefault: false,
                                  placeholder: addressData,
                                  revisit: true,
                                });
                              } else {
                                lookup(coordinates)
                                  .then(({ data }) => {
                                    document
                                      .querySelectorAll('.remove-on-lookup')
                                      .forEach(el => {
                                        el.setAttribute(
                                          'style',
                                          'display:none;'
                                        );
                                      });

                                    this.setState({
                                      coordinates,
                                      data,
                                      lookupPending: false,
                                      placeholder: placeName,
                                      revisit: false,
                                      yourDistrict: false,
                                    });
                                  })
                                  .catch(() =>
                                    this.setState({
                                      data: null,
                                      lookupError: true,
                                      lookupPending: false,
                                      yourDistrict: false,
                                    })
                                  );
                              }
                            });
                          })
                          .catch(err => {
                            console.log(err);
                            console.log('CATCH');
                          });

                        this.getContainerWidth();

                        window.addEventListener('resize', () => {
                          this.getContainerWidth();
                        });
                      }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize());
  }

  onClear() {
    this.setState({ value: '' });
  }

  onChange(value) {
    this.setState({ value }, this.debouncedHandleGeocode);
  }

  handleGeocode() {
    const { value: input } = this.state;

    getPredictions(input)
      .then(results => this.setState({ results }))
      .catch(() => this.setState({ results: [] }));
  }

  onSelect({ name, placeId }) {
    this.setState({
      lookupError: false,
      lookupPending: true,
      value: name,
      placeholder: name,
      revisit: false
    });

    this.placesService.getDetails(
      {
        fields: ['geometry.location'],
        placeId,
        sessionToken,
      },
      result => {
        const {
          lat: latitude,
          lng: longitude,
        } = result.geometry.location.toJSON();

        const coordinates = { latitude, longitude };

        lookup(coordinates)
          .then(({ data }) => {
            document.querySelectorAll('.remove-on-lookup').forEach(el => {
              el.setAttribute('style', 'display:none;');
            });
            this.setState({
              coordinates,
              data,
              lookupPending: false,
              lookupDefault: false,
              yourDistrict: true
            });

            set('your-races-lookup', data);
            set('your-races-address', name)
          })
          .catch(() =>
            this.setState({
              data: null,
              lookupError: true,
              lookupPending: false,
              lookupDefault: false,
            })
          );
      }
    );
  }

  render() {
    const {
      coordinates,
      data,
      lookupError,
      lookupPending,
      lookupDefault,
      placeholder,
      results,
      value,
      bodyWidth,
      width,
      revisit,
      yourDistrict
    } = this.state;

    let addressFeedback = null;

    if (lookupPending) {
      addressFeedback = <p>Finding your details... </p>;
    }

    if (lookupError) {
      addressFeedback = (
        <p>
          Hmm... we were unable to find you in Texas. Please check your address
          and {widont('try again!')}
        </p>
      );
    }

    if (!lookupPending && !lookupError) {
      if (!lookupDefault && revisit) {
        addressFeedback = <p>{widont('We found your district! We remembered the address you entered before.')}</p>;
      } else if (!lookupDefault && yourDistrict) {
        addressFeedback = <p>We found your district!</p>
      } else {
        addressFeedback = null;
      }
    }

    return (

      <div class="lookup-container">
        <div class="address-input t-sans">
          <label class="label" for="address-input">
            ENTER YOUR ADDRESS
          </label>
          <Typeahead
            inputProps={{
              id: 'address-input',
              class: 'input',
              placeholder: placeholder,
            }}
            items={results}
            getItemValue={item => ({
              name: item.description,
              placeId: item.place_id,
            })}
            value={value}
            onChange={this.onChange}
            onClear={this.onClear}
            onSelect={this.onSelect}
            renderItem={(item, isHighlighted) => (
              <li
                class={cx('item', {
                  'item-highlighted': isHighlighted,
                })}
                key={item.id}
              >
                {item.description}
              </li>
            )}
            renderAttribution={() => (
              <li class="item item-attribution">
                <img src={googleIMG} alt="Powered by Google" />
              </li>
            )}
            shouldItemRender={shouldItemRender}
            renderInput={props => (
              <input
                {...props}
                ref={el => {
                  props.ref(el);
                  this.inputRef = el;
                }}
              />
            )}
          />
          <div id="address-feedback"></div>
          <div id="district-info-container"></div>
          {/* <div id="primary-ballot-container"></div> */}

          <Portal node={document.getElementById('address-feedback')}>
            {addressFeedback}
          </Portal>

          <Portal node={document.getElementById('district-info-container')}>
            {data && (
              <AsyncDistrictViewer
                district={data['tx_house'].district}
              />
            )}
          </Portal>
        </div>
      </div>
    );
  }
}

export default Locator;
